/** Pure display helpers shared by web and native; no networking, storage or UI imports. */
export function currencyFractionDigits(currency: string): number {
  try {
    return new Intl.NumberFormat("en", { style: "currency", currency }).resolvedOptions().maximumFractionDigits ?? 2;
  } catch { return 2; }
}
export function currencyScale(currency: string): number {
  return 10 ** currencyFractionDigits(currency);
}
export function formatMoneyMinor(minor: number, currency = "AED", locale = "en-AE"): string {
  return new Intl.NumberFormat(locale, {
    style: "currency", currency,
    minimumFractionDigits: currencyFractionDigits(currency),
    maximumFractionDigits: currencyFractionDigits(currency)
  }).format(minor / currencyScale(currency));
}
